import { t } from '@/features/i18n/utils';
import { useEffect } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import { bidComparisonSheetsQuery } from '@/features/bid-comparison/queries';
import { lastSelectedSheetIdAtom } from '@/features/bid-comparison/store';
import { bidComparisonScope } from '@/features/bid-comparison/utils';
import { useSetAtom } from 'jotai';
import z from 'zod';
import { ArrowDataTransferHorizontalIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { chatSidePanelOpenAtom } from '@/features/chat/store';
import { ProcurementBreadcrumbs } from '@/features/subcontractor-bids/components/procurement-breadcrumbs';
import { BidComparisonSheetPage } from '@/features/bid-comparison/components/bid-comparison-sheet-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId',
)({
  component: RouteComponent,
  beforeLoad: async ({ context, params }) => {
    const sheets = await context.queryClient.query({
      ...bidComparisonSheetsQuery(params.workspaceId, bidComparisonScope(params)),
      staleTime: 'static',
    });
    if (!sheets.some((s) => s.id === params.sheetId))
      throw redirect({
        to: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison',
        params,
        replace: true,
      });
  },
  loader: ({ params }) => {
    getDefaultStore().set(lastSelectedSheetIdAtom(params), params.sheetId);
  },
  validateSearch: z.object({
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId } = Route.useParams();
  const setAiChatSidePanelOpen = useSetAtom(chatSidePanelOpenAtom);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  useEffect(() => {
    setAiChatSidePanelOpen(true);
  }, []);

  return (
    <div className="@container flex flex-col min-h-0 grow">
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId"
          params={{ projectId, workspaceId, procurementId }}
        />
        <ProcurementBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={ArrowDataTransferHorizontalIcon} />
            {t({ en: 'Compare bids', nb: 'Sammenlign tilbud' })}
          </BreadcrumbPage>
        </ProcurementBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <BidComparisonSheetPage />
    </div>
  );
}
